import { FC } from "react";
import { UploadedDocumentRow } from "./types";

const COMPONENT_LABELS = [
	{ key: "balanceSheet", label: "BS" },
	{ key: "incomeStatement", label: "IS" },
	{ key: "cashFlowStatement", label: "CF" },
	{ key: "notes", label: "Notes" },
	{ key: "wipSchedule", label: "WIP" },
	{ key: "cpaReport", label: "CPA Report" },
] as const;

type ComponentCellProps = {
	row: UploadedDocumentRow;
};

export const ComponentCell: FC<ComponentCellProps> = ({ row }) => {
	const components = row.financialExtraction?.componentsPresent;

	if (!components) {
		return <span className="text-tertiary">—</span>;
	}

	const present = COMPONENT_LABELS.filter(({ key }) => components[key]);

	if (present.length === 0) {
		return <span className="text-tertiary">—</span>;
	}

	return (
		<div className="flex flex-wrap gap-1">
			{present.map(({ key, label }) => (
				<span
					key={key}
					className="inline-flex items-center rounded border border-bc-default bg-surface-neutral px-1.5 py-0.5 text-[11px] font-medium text-secondary"
				>
					{label}
				</span>
			))}
		</div>
	);
};
